import React, { useCallback, useEffect, useState } from "react";
import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { Accordion, AccordionItem, AccordionButton, AccordionCollapse, AccordionBody } from "react-bootstrap";
import DataTable from "react-data-table-component";
import { BsArrowDown, BsChevronDown } from "react-icons/bs";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../hooks/apiClient";
import TextSpinner from "../../../components/UI/Spinner/TextSpinner";
import DateTime from "../../../components/Formatters/DateTime";
import useSetGuard from "../../../hooks/useSetGuard";
import FileDownloader from "../../../components/UI/Button/FileDownloader";
import constants from "../../Constants";

const cols = [
  {
    name: "Descrição",
    selector: (row) => row.contextoDescricao,
    maxWidth: "40%",
  },
  {
    name: "Nome Arquivo",
    selector: (row) => row.arquivoNome,
    maxWidth: "25%",
  },
  {
    name: "Data Geração",
    selector: (row) => row.inclusao,
    cell: (row) => <DateTime value={row.inclusao} stringFormat="dd/MM/yyyy HH:mm:ss" />,
    center: true,
    maxWidth: "20%",
  },
  {
    name: "Arquivo",
    selector: (row) => row.arquivo,
    cell: (row) => <FileDownloader binario={row.arquivo} tooltip="Visualizar Documento" />,
    center: true,
    maxWidth: "15%",
  },
];

const AssinadorAccordion = ({ item, index, contextAction, SearchParameters, PageNumber, history }) => {
  const setGuardClient = useSetGuard();
  const [arquivosSelecionados, setArquivosSelecionados] = useState({});
  const [rows, setRows] = useState([]);
  const [pageSize, setPageSize] = useState(50);
  const [pageNumber, setPageNumber] = useState(PageNumber);
  const [totalRows, setTotalRows] = useState(1);
  const [searchParameters] = useState(SearchParameters);

  const preparaAssinar = useCallback(
    (i) => {
      if (arquivosSelecionados.length > 0) {
        setGuardClient.assinar(arquivosSelecionados.map((row) => row.safePayload));
      } else {
        document.getElementById(`alerta-${i}`).innerHTML = "Selecione pelo menos 1 documento para assinar";
      }
    },
    [arquivosSelecionados, setGuardClient],
  );

  const { request, data, errors, isLoading } = useApiClient();

  useEffect(() => {
    setRows([]);
    request(apiRoutes.usuarios.arquivo.fila, {
      ...searchParameters,
      contextoGrupo: item !== "Outras" ? item : null,
      pageSize,
      pageNumber,
    });
  }, [request, searchParameters, pageSize, pageNumber, item]);

  const handlePageChange = useCallback((newPageNumber) => {
    setPageNumber(newPageNumber);
  }, []);

  const handlePerRowsChange = useCallback((newPageSize) => {
    setPageSize(newPageSize);
    setPageNumber(1);
  }, []);

  useEffect(() => {
    if (data?.result) {
      if (data.result.length && !data.result[0].totalRows) {
        console.error(`[DEV] A propriedade "totalRows" é obrigatória nos resultados paginados. `);
        return;
      }
      setRows(data.result || []);
      setTotalRows(data.result.length ? data.result[0].totalRows : 0);
    }

    if (errors) {
      toast.error(errors.message);
    }
  }, [data, errors]);
  return (
    <>
      {setGuardClient.guardLink}

      {!!rows.length && (
        <Accordion key={index}>
          <Card>
            <AccordionItem eventKey={item}>
              <AccordionButton as={Card.Header}>
                <i>
                  <BsChevronDown />
                </i>
                {item !== "" ? ` ${item}` : "Outras"}
              </AccordionButton>
              <AccordionCollapse eventKey={item}>
                <AccordionBody>
                  <DataTable
                    noHeader
                    keyField=""
                    columns={cols}
                    data={item === "Outras" ? rows.filter((row) => row.contextoGrupo === null) : rows}
                    progressPending={isLoading}
                    noDataComponent="Nenhum registro para exibir"
                    progressComponent={<TextSpinner />}
                    sortIcon={<BsArrowDown />}
                    pagination
                    paginationServer
                    paginationTotalRows={
                      item === "Outras" ? rows.filter((row) => row.contextoGrupo === null).length : totalRows
                    }
                    selectableRows
                    contextActions={contextAction}
                    contextMessage={{ singular: "arquivo selecionado", plural: "arquivos selecionados" }}
                    pointerOnHover
                    onRowClicked={(row) => {
                      setGuardClient.assinar(row.safePayload);
                    }}
                    onChangeRowsPerPage={handlePerRowsChange}
                    onChangePage={handlePageChange}
                    paginationComponentOptions={constants.paginationComponentOptions}
                    paginationPerPage={item === "Outras" ? 50 : 50}
                    onSelectedRowsChange={(state) => {
                      setArquivosSelecionados(state.selectedRows);
                    }}
                  />
                  <Form.Group as={Row} className="d-flex flex-row">
                    <Col sm="12">
                      <Form.Label className="small">
                        <span className="alerta" hidden={arquivosSelecionados.length > 0} id={`alerta-${index}`}>
                          &nbsp;
                        </span>
                      </Form.Label>
                    </Col>
                    <Col sm="12" className="form-inline justify-content-start">
                      <Button
                        className="btn btn-primary btn-md mr-2" // btn btn-primary btn-md mr-2 btn btn-primary
                        disabled={!rows.length}
                        onClick={() => preparaAssinar(index)}
                      >
                        Assinar
                      </Button>
                    </Col>
                  </Form.Group>
                </AccordionBody>
              </AccordionCollapse>
            </AccordionItem>
          </Card>
        </Accordion>
      )}
    </>
  );
};

export default AssinadorAccordion;
